<template>
    <header class="app-header navbar">
        <slot></slot>
    </header>
</template>
<script>
    export default {
        name: 'navbar',
        created () {
            this._navbar = true
        }
    }
</script>



// WEBPACK FOOTER //
// Navbar.vue?4b209fed